import { HelpIcon } from '@/shared/components/HelpIcon'

/**
 * All-clear stand-in for the risk cards: the risk section leads the dashboard, so when
 * neither list has entries it must say "clean" rather than silently disappear (an absent
 * lead section reads as "no data", not "no risk").
 */
export function RiskAllClearCard() {
  return (
    <div className="card fu" style={{ marginBottom: 20 }}>
      <div className="card-header">
        <div>
          <div className="kicker">Risk</div>
          <h3 style={{ fontSize: '0.95rem' }}>Highest risk</h3>
        </div>
        <HelpIcon track="help_risk_all_clear" title="Highest risk" kicker="// what this implies">
          <p>This card replaces the two "Highest risk" lists when neither has anything to
          rank: no <strong>latest published module version</strong> and no workspace's
          <strong> current state</strong> carries an unresolved <strong>critical</strong> or
          <strong> high</strong> finding.</p>
          <p>Only critical and high findings count here - medium and lower findings can
          still be open, and the "Open findings" rings below show the full severity
          spread for the same artefacts.</p>
        </HelpIcon>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '18px' }}>
        <span style={{ fontFamily: 'var(--head)', fontSize: '1.2rem', color: 'var(--green)' }}>✓</span>
        <span style={{ fontFamily: 'var(--mono)', fontSize: '0.72rem', color: 'var(--text3)' }}>
          No critical or high findings in the latest published module versions or state workspaces.
        </span>
      </div>
    </div>
  )
}
